// Modules
import PropTypes from "prop-types";
// Material UI
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function InitializeLocation({ children, adapter, locale }) {
    return (
        <LocalizationProvider dateAdapter={adapter === "date" ? AdapterDateFns : AdapterDayjs} locale={locale}>
            {children}
        </LocalizationProvider>
    );
}

InitializeLocation.propTypes = {
    children: PropTypes.node.isRequired,
    adapter: PropTypes.string,
    locale: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default InitializeLocation;
